import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Box, Flex } from 'rebass';
import { array, bool, func, string } from 'prop-types';
import Modal from '../../../modal/Modal';
import { getProductContractGroupsData } from '../selectors';
import { fetchAdminAccountContracts } from '../../account/actions';
import { getSelectedAccountId } from '../../../admin/account/selectors';
import DeleteButton from '../../../admin/common/DeleteButton';
import { updateProductContractGroup as updateProductContractGroupAction } from '../actions';
import { sortBy } from '../../../util/lodash';

const GroupsInAcctMgmtModal = ({
  closeModal,
  fetchAdminAccountContracts,
  isOpen,
  productContractGroups,
  selectedAccountId,
  updateProductContractGroup
}) => {
  const [disabledButtons, setDisabledButtons] = useState({});

  // TODO: Update the way we fetch all groups under a given account, once the BE search endpoint is ready
  const productContractGroupsForAccount = productContractGroups.filter(({ accounts }) =>
    accounts?.includes(selectedAccountId)
  );

  const onClose = () => {
    closeModal();
    setDisabledButtons({});
  };

  const unlinkProductContractGroup =
    ({ accounts, id }) =>
    async () => {
      setDisabledButtons(prevState => ({ ...prevState, [id]: true }));

      const res = await updateProductContractGroup({
        productContractGroupId: id,
        data: {
          accounts: accounts.filter(account => account !== selectedAccountId)
        }
      });

      setDisabledButtons(prevState => ({ ...prevState, [id]: res ? false : null }));

      fetchAdminAccountContracts();
    };

  return (
    <Modal
      title='Product Contract Groups'
      content={() =>
        productContractGroupsForAccount.length ? (
          <Flex flexDirection='column' style={{ width: '100%' }}>
            {sortBy(productContractGroupsForAccount, ({ name }) => name.toUpperCase()).map(
              ({ accounts, id, name }) =>
                disabledButtons[id] !== null && (
                  <Flex justifyContent='space-between' key={name}>
                    <Box>{name}</Box>
                    <DeleteButton
                      disabled={disabledButtons[id]}
                      onClick={unlinkProductContractGroup({ accounts, id })}
                      style={{ opacity: disabledButtons[id] ? 0.5 : 1 }}
                    />
                  </Flex>
                )
            )}
          </Flex>
        ) : (
          'There are no groups under this account.'
        )
      }
      isOpen={isOpen}
      closeModal={onClose}
    />
  );
};

GroupsInAcctMgmtModal.propTypes = {
  closeModal: func.isRequired,
  fetchAdminAccountContracts: func.isRequired,
  isOpen: bool.isRequired,
  productContractGroups: array.isRequired,
  selectedAccountId: string.isRequired,
  updateProductContractGroup: func.isRequired
};

export default connect(
  state => ({
    productContractGroups: getProductContractGroupsData(state),
    selectedAccountId: getSelectedAccountId(state)
  }),
  { fetchAdminAccountContracts, updateProductContractGroup: updateProductContractGroupAction }
)(GroupsInAcctMgmtModal);
